export default "/images/vendor/flag-icon-css/flags/4x3/cv.svg?434373304db5970887de778fb452f3a0";